import angular from "angular";
import SignatureList from "./SignatureList.vue";
import Vue from "vue";
import "ngVue";

export default angular
  .module("directives.signaturelist", [])
  .directive("dsSignatureList", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DsSignatureList", SignatureList));
    },
  ]);
